import { configureStore } from '@reduxjs/toolkit';
import clustersReducer from './slices/clustersSlice';
import podMetricsReducer from './slices/podMetricsSlice';
import kafkaLagReducer from './slices/kafkaLagSlice';
import { TypedUseSelectorHook } from 'react-redux';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import userReducer from './slices/userSlicer';
import keycloakPodMetricsReducer from './slices/keycloakPodMetricSlice';
import maintenanceReducer from './slices/maintenanceSlice';
import criticalServicesReducer from './slices/criticalServicesSlice';
import configReducer from './slices/configSlice';

export const store = configureStore({
  reducer: {
    clusters: clustersReducer,
    podMetrics: podMetricsReducer,
    kafkaLag: kafkaLagReducer,
    user: userReducer,
    keycloakPodMetrics: keycloakPodMetricsReducer,
    maintenance: maintenanceReducer,
    criticalServices: criticalServicesReducer,
    config: configReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 
export const useAppDispatch = () => useDispatch<AppDispatch>();
export type DispatchType = typeof store.dispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;